import {
	has,
	unitOf,
	type Course,
	type LetterView,
	type UnitView,
	type WordView,
} from "@aybuben/core/content/course.ts";
import { started } from "@aybuben/core/progress/query.ts";
import type { GameState } from "@aybuben/core/state.ts";
import { TRACK_RULES } from "@aybuben/core/tracks.ts";

export interface LetterTile {
	letter: LetterView;
	/** Its unit has been started. Unmet tiles stay tappable. */
	seen: boolean;
}

export interface LettersModel {
	met: number;
	total: number;
	tiles: LetterTile[];
}

/** The alphabet grid. Letters met only ever goes up, which is why it is the one count shown. */
export function lettersModel(st: GameState, letters: readonly LetterView[]): LettersModel {
	// every letter belongs to a unit; the validator asserts it
	const tiles = letters.map((letter) => ({ letter, seen: started(st, unitOf(letter.id)) }));
	return { met: tiles.filter((t) => t.seen).length, total: letters.length, tiles };
}

export interface LetterSheetModel {
	/** The unit that teaches the letter. */
	unit: UnitView;
	/** Up to three lowercase-track words that contain it. */
	words: WordView[];
	audio: string | undefined;
}

export function letterSheet(course: Course, L: LetterView): LetterSheetModel {
	const id = unitOf(L.id).id;
	// unitOf found the unit in this course, so its view exists.
	const unit = course.views.units().find((x) => x.id === id)!;
	const words = course.views
		.wordUnits()
		.filter((x) => TRACK_RULES[x.unit.track].letterCase === "lower" && has(x.word.a, L.l))
		.slice(0, 3)
		.map((x) => x.word);
	return { unit, words, audio: course.itemById(L.id).audio };
}
